
export default function Concept() {
  const features = [
    {
      icon: 'ri-plant-line',
      title: '地元の新鮮な食材',
      description: '湘南で獲れた新鮮な魚介や野菜、厳選されたオーガニックコーヒーを使用しています。'
    },
    {
      icon: 'ri-leaf-line',
      title: 'サステナブルな取り組み',
      description: 'プラスチックフリーの徹底、定期的なビーチクリーン活動で海を守ります。'
    },
    {
      icon: 'ri-heart-line',
      title: '世界の味を湘南で',
      description: 'オーナーが世界中の旅で得たインスピレーションを、一皿一皿に込めています。'
    }
  ];

  return (
    <section id="concept" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Riding the Flavor, Living the Coast
          </h3>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {feature.title}
              </h4>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div 
              className="h-64 md:h-auto bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/b972d4967ea119dfa81f111282f6b604.jpg)'
              }}
            ></div>
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h4 className="text-2xl font-bold text-gray-900 mb-4">
                海を愛する、すべての人へ
              </h4>
              <p className="text-gray-600 leading-relaxed mb-4">
                元プロサーファーのオーナーKenjiが、世界中の海を旅して得た経験とインスピレーションを形にしたカフェです。
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                美しい海を次世代に残すため、私たちは日々サステナブルな取り組みを実践しています。プラスチックフリーの徹底、地元食材の活用、そして毎月のビーチクリーン活動。
              </p>
              <p className="text-gray-600 leading-relaxed">
                ここは、波の音を聞きながら、心と体を癒す特別な場所です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
